import React from "react";
import { SOCIAL_LINKS } from "../../constants/socialLinks";

const FooterSocial = ({ isMobile = false }) => {
  const iconSize = isMobile ? "h-7 w-7" : "h-8 w-8";
  const hoverClass = isMobile ? "" : "hover:opacity-80 transition-opacity";

  return (
    <div className={`flex justify-center items-center gap-4 `}>
      {!isMobile && <span className="text-xl">تواصل معنا</span>}
      {isMobile && <span className="text-lg font-medium">تواصل معنا</span>}
      <div className="flex gap-4">
        <a
          href={SOCIAL_LINKS.FACEBOOK}
          target="_blank"
          rel="noopener noreferrer"
          className={hoverClass}
          aria-label="Facebook"
        >
          <img
            src="/images/facebook.png"
            alt="Facebook"
            className={iconSize}
            loading="lazy"
            decoding="async"
          />
        </a>
        <a
          href={SOCIAL_LINKS.TELEGRAM}
          target="_blank"
          rel="noopener noreferrer"
          className={hoverClass}
          aria-label="Telegram"
        >
          <img
            src="/images/telegram.png"
            alt="Telegram"
            className={iconSize}
            loading="lazy"
            decoding="async"
          />
        </a>
        <a
          href={SOCIAL_LINKS.EMAIL}
          className={hoverClass}
          aria-label="Email"
        >
          <img
            src="/images/email.png"
            alt="Email"
            className={iconSize}
            loading="lazy"
            decoding="async"
          />
        </a>
      </div>
    </div>
  );
};

export default FooterSocial;